module.exports = __webpack_public_path__ + "static/media/laser.60b87a7d.svg";